<!-- <div class="templateBody" *ngIf="!isLoggedIn"> -->
<div class="templateBody">
  <form [formGroup]="loginForm" novalidate>
    <h3 *ngIf="showWarning" style="color: red">Please use Google Chrome to access the IFP tool.</h3>
    <h2 style="margin-bottom: 20px;">Log in</h2>

    <!-- <a href="/loginMyAccess" role="menuitem" style="font-size:16px">Log in using MyAccess</a> -->

    <div class="form-group" [ngClass]="isValid()" style="margin-top:15px;">
      <label>Email</label>
      <input type="email" class="form-control reduce-width" formControlName="loginEmail">
      <small class="small-block">Enter your e-mail address</small>
    </div>
    <div class="form-group" [ngClass]="isValid()">
      <label>Password</label>
      <input type="password" class="form-control reduce-width" formControlName="loginPassword">
      <small class="small-block">Enter the password that accompanies your e-mail.</small>
    </div>

    <div *ngIf="isValid() == 'has-error'">
      <small class="small-block" style="color: red">Invalid e-mail or password.</small>
      <!-- <button class="btn btn-primary" style="margin-bottom:30px;margin-top:5px;" (click)="requestNewPass()"> Request new
        password</button> -->
    </div>

    <button type="submit" [disabled]="!loginForm.valid" class="btn btn-primary"
      style="margin-bottom:20px;margin-top:10px;" (click)="onLogin()">Log in</button>

    <div>
      <button type="submit" [disabled]="!showPasswordReset" class="btn btn-secondary"
        style="margin-bottom:10px;margin-top:10px;" (click)="requestNewPassword()">Forgot Password</button>
    </div>

    <p>
      <a (click)="requestNewAccount()" class="btn btn-link btn-sm btn-custom">Request User Account</a>
    </p>

    <p>
      <a href="mailto:9-ajv-filter.tool&#64;faa.gov">Contact Us</a>
    </p>
  </form>

  <p-dialog header="Password Reset" [(visible)]="showPasswordResetSuccess" [modal]="true" [closeOnEscape]="false">
    <span>Your password has been reset successfully and has been sent your email address. Once you log in,
      you can change your password by clicking on the “My Account” link.</span>
    <p-footer>
      <button type="button" pButton (click)="resetParams()" label="Close"></button>
    </p-footer>
  </p-dialog>

  <p-dialog header="Password Reset" [(visible)]="showPasswordResetFail" [modal]="true" [closeOnEscape]="false">
    <span>Password reset failed. Please contact 9-ajv-filter.tool&#64;faa.gov for help.</span>
    <p-footer>
      <button type="button" pButton (click)="resetParams()" label="Close"></button>
    </p-footer>
  </p-dialog>

  <!-- <p-dialog header="Account Not Found" [(visible)]="showNoAccount" [modal]="true" [closeOnEscape]="false">
    <span>Account not found for {{invalidEmail}}. Please use the <b>Request User Account</b> feature to request an
      account.</span>
    <p-footer>
      <button type="button" pButton (click)="resetParams('1')" label="Close"></button>
    </p-footer>
  </p-dialog> -->
</div>